import React from 'react';
import './CareerPage.css';

import { PageTitle, Position, Heading } from '../../../components';
import { benefits, careerIntro, images, positions } from '../../../constants';



const CareerPage = () => { 

  return ( 
    <>  
      {/* Page Title Section */}
      <PageTitle title={'Careers'} page={'Careers'} />

      <section className='career'>

        {/* Career Introduction Section */}
        <section className='career-intro'> 

          {/* Career Intro Content */}
          <div className='content'>

            {/* Section Heading */}
            <Heading title={careerIntro.heading} subTitle={careerIntro.sub} sideHeading={true} />

            {/* Career Description */}
            <p>{careerIntro.description}</p>

            {/* Key Features List */}
            <ul className="career-features">
            {careerIntro.points.map((point, index) => (
              <li key={index}>
                <div className='icon'>{point.icon}</div> {/* Point Icon */}
                <span>{point.title}</span> {/* Point Title */}
              </li>
            ))}
          </ul> 

          </div>

          <div className='image'>
            <img src={images.careerIntro} alt='Career-Pic' /> {/* Career Image */}
          </div>

        </section>

        {/* Career Benefits Section */}
        <section className='career-benefits'>

          {/* Loop through each benefit and render it */}
          {benefits.map((benefit) => (
            <div className="benefit-item" key={benefit.id}>
              <div className='icon'>{benefit.icon}</div> {/* Benefit Icon */}
              <h3>{benefit.title}</h3> {/* Benefit Title */}
              <p>{benefit.description}</p> {/* Benefit Description */}
            </div>
          ))}

        </section>

        {/* Open Positions Section */}
        <section className='career-positions'>

          {/* Section Heading */}
          <Heading title={'Job Opportunities'} subTitle={'Join Our Team'} />

          {/* Positions Container */}
          <div className='box-container'>
            {/* Loop through each available position and render it */}
            {positions.map((position) => (
              <Position key={position.id} position={position} />
            ))}
          </div>

        </section>

      </section>

    </>
  )
}

export default CareerPage;